import React, { useState } from "react";
import { Avatar, IconButton } from "@material-ui/core";
import {
  AttachFile,
  MoreVert,
  SearchOutlined,
  Mic,
  InsertEmoticon,
} from "@material-ui/icons";
import "./Chat.css";
import { useDispatch } from "react-redux";
import { createMessage } from "../actions/messages";

const Chat = ({ messages }) => {
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();

  const submitHandler = (e) => {
    e.preventDefault();
    debugger;
    dispatch(createMessage({ message, name: "shreha" }));
    setMessage("");
  };

  return (
    <div className="chat">
      <div className="chat__header">
        <Avatar />
        <div className="chat__headerInfo">
          <h3>Room name</h3>
          <p>Last seen at ...</p>
        </div>
        <div className="chat__headerRight">
          <IconButton>
            <SearchOutlined />
          </IconButton>
          <IconButton>
            <AttachFile />
          </IconButton>
          <IconButton>
            <MoreVert />
          </IconButton>
        </div>
      </div>

      <div className="chat__body">
        {messages.map((message) => (
          <p
            className={`chat__message ${
              message.received === "false" && "chat__receiver"
            }`}
          >
            <span className="chat__name">{message.name}</span>
            {message.message}
            <span className="chat__timestamp">{message.createdAt}</span>
          </p>
        ))}
      </div>
      <div className="chat__footer">
        <InsertEmoticon />
        <form onSubmit={submitHandler}>
          <input
            placeholder="Type a message"
            value={message}
            onChange={(event) => setMessage(event.target.value)}
          />
          <button type="submit">Send Message</button>
        </form>
        <Mic />
      </div>
    </div>
  );
};

export default Chat;
